export default "__VITE_ASSET__Bi$s2hqk__"